import {
  SnackbarProvider as NotistackSnackbarProvider,
  SnackbarProviderProps
} from "notistack";
import SnackbarComponent from "./snackbar-component";

export const SnackbarProvider = (props: SnackbarProviderProps) => {
  return (
    <NotistackSnackbarProvider
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      Components={{
        success: SnackbarComponent,
        error: SnackbarComponent,
        info: SnackbarComponent
      }}
      {...props}
    ></NotistackSnackbarProvider>
  );
};
